'use client';

import { Slider as RadixSlider } from 'radix-ui';
import type { ComponentProps } from 'react';
import { cn, focusRing } from './cn';

/**
 * A value picked along a range: the filled part in the accent. One thumb per value; each takes the
 * slider's `aria-label`.
 */
export function Slider({ className, ...props }: ComponentProps<typeof RadixSlider.Root>) {
  const values = props.value ?? props.defaultValue ?? [props.min ?? 0];
  return (
    <RadixSlider.Root
      className={cn(
        'relative flex w-full touch-none items-center select-none data-[disabled]:opacity-50',
        className,
      )}
      {...props}
    >
      <RadixSlider.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-crow-raised">
        <RadixSlider.Range className="absolute h-full bg-crow-accent" />
      </RadixSlider.Track>
      {values.map((_, index) => (
        <RadixSlider.Thumb
          // Thumbs have no identity beyond their position.
          // biome-ignore lint/suspicious/noArrayIndexKey: see above
          key={index}
          aria-label={props['aria-label']}
          className={cn(
            'block size-4 shrink-0 rounded-full border border-crow-accent bg-crow-surface shadow-[0_1px_2px_rgb(0_0_0/0.2)] transition-shadow duration-[var(--crow-dur-1)] hover:shadow-[0_0_0_4px_color-mix(in_oklch,var(--crow-accent)_22%,transparent)] disabled:pointer-events-none',
            focusRing,
          )}
        />
      ))}
    </RadixSlider.Root>
  );
}
